import { differenceInDays } from "date-fns";
import { useTranslation } from "react-i18next";
import * as yup from "yup";

export const appl10149ValidationSchema = () => {
  const { t } = useTranslation();
  return yup
    .object()
    .shape({
      acceptedFinancialReport: yup
        .string()
        .required(t("Το πεδίο είναι υποχρεωτικό")),
      d50_id: yup.object().required(t("Το πεδίο είναι υποχρεωτικό")),
      boardDate: yup
        .date()
        .typeError(t("Το πεδίο πρέπει να είναι ημερομηνία"))
        .max(
          new Date(),
          t(
            "Η ημερομηνία απόφασης οργάνου δεν μπορεί να είναι μεταγενέστερη της ημερομηνίας υποβολής της αίτησης.",
          ),
        )
        .required(t("Το πεδίο είναι υποχρεωτικό")),
      fudocPrakt1: yup.string().required(t("Το πεδίο είναι υποχρεωτικό")),
      usageFromDate: yup
        .date()
        .typeError(t("Το πεδίο πρέπει να είναι ημερομηνία"))
        .required(t("Το πεδίο είναι υποχρεωτικό"))
        .test(
          "is-before-start-date",
          t(
            "Η ημερομηνία έναρξης πρέπει να είναι πριν από την ημερομηνία λήξης",
          ),
          function (value) {
            const { usageToDate } = this.parent;
            if (!usageToDate || !value) return true;
            return value < usageToDate;
          },
        ),
      usageToDate: yup.date().required(t("Το πεδίο είναι υποχρεωτικό")),
      totalActive: yup
        .string()
        .required(t("Το πεδίο είναι υποχρεωτικό"))
        .matches(
          /^[0-9]*(\.)?[0-9]{0,2}$/,
          `${t("Το πεδίο πρέπει να είναι αριθμός")}. ${t("Το ποσό πρέπει να έχει μέχρι δύο δεκαδικά ψηφία με τελεία (πχ. 9999.99)")}.`,
        ),
      businessCircle: yup
        .string()
        .required(t("Το πεδίο είναι υποχρεωτικό"))
        .matches(
          /^(-)?[0-9]+(\.)?[0-9]{0,2}$/,
          `${t("Το πεδίο πρέπει να είναι αριθμός")}. ${t("Το ποσό πρέπει να έχει μέχρι δύο δεκαδικά ψηφία με τελεία (πχ. 9999.99)")}.`,
        ),
      employees: yup
        .string()
        .required(t("Το πεδίο είναι υποχρεωτικό"))
        .matches(
          /^[0-9]*(\.)?[0-9]{0,2}$/,
          `${t("Το πεδίο πρέπει να είναι αριθμός")}. ${t("Το ποσό πρέπει να έχει μέχρι δύο δεκαδικά ψηφία με τελεία (πχ. 9999.99)")}.`,
        ),
      assets: yup.string().matches(/^[0-9]*(\.)?[0-9]{0,2}$/, {
        message: `${t("Το πεδίο πρέπει να είναι αριθμός")}. ${t("Το ποσό πρέπει να έχει μέχρι δύο δεκαδικά ψηφία με τελεία (πχ. 9999.99)")}.`,
        excludeEmptyString: true,
      }),
      reserves: yup.string().matches(/^[0-9]*(\.)?[0-9]{0,2}$/, {
        message: `${t("Το πεδίο πρέπει να είναι αριθμός")}. ${t("Το ποσό πρέπει να έχει μέχρι δύο δεκαδικά ψηφία με τελεία (πχ. 9999.99)")}.`,
        excludeEmptyString: true,
      }),
      requirements: yup.string().matches(/^[0-9]*(\.)?[0-9]{0,2}$/, {
        message: `${t("Το πεδίο πρέπει να είναι αριθμός")}. ${t("Το ποσό πρέπει να έχει μέχρι δύο δεκαδικά ψηφία με τελεία (πχ. 9999.99)")}.`,
        excludeEmptyString: true,
      }),
      prepayments: yup.string().matches(/^[0-9]*(\.)?[0-9]{0,2}$/, {
        message: `${t("Το πεδίο πρέπει να είναι αριθμός")}. ${t("Το ποσό πρέπει να έχει μέχρι δύο δεκαδικά ψηφία με τελεία (πχ. 9999.99)")}.`,
        excludeEmptyString: true,
      }),
      equityTotal: yup.string().matches(/^(-)?[0-9]+(\.)?[0-9]{0,2}$/, {
        message: `${t("Το πεδίο πρέπει να είναι αριθμός")}. ${t("Το ποσό πρέπει να έχει μέχρι δύο δεκαδικά ψηφία με τελεία (πχ. 9999.99)")}.`,
        excludeEmptyString: true,
      }),
      obligationsTotal: yup.string().matches(/^[0-9]*(\.)?[0-9]{0,2}$/, {
        message: `${t("Το πεδίο πρέπει να είναι αριθμός")}. ${t("Το ποσό πρέπει να έχει μέχρι δύο δεκαδικά ψηφία με τελεία (πχ. 9999.99)")}.`,
        excludeEmptyString: true,
      }),
      resultsNoTax: yup.string().matches(/^(-)?[0-9]+(\.)?[0-9]{0,2}$/, {
        message: `${t("Το πεδίο πρέπει να είναι αριθμός")}. ${t("Το ποσό πρέπει να έχει μέχρι δύο δεκαδικά ψηφία με τελεία (πχ. 9999.99)")}.`,
        excludeEmptyString: true,
      }),
      fuXhtmlFiles: yup.object().required(t("Το πεδίο είναι υποχρεωτικό")),
      fudocWeb: yup.string().nullable(),
      webDate: yup.date().nullable(),
      webURL: yup.string().url().nullable(),
      paperDate: yup.date().nullable().default(null),
      paperName: yup.string().nullable(),
      fudocPaper: yup.string().nullable(),
      auditCompanies: yup.array().default([]),
      auditPersons: yup.array().default([]),
    })
    .test(
      "has filled all of website",
      t(
        "Εάν επιθυμείτε να εισάγετε τα στοιχεία της ιστοσελίδας, πρέπει να συμπληρώσετε όλα τα αντίστοιχα πεδία.",
      ),
      (value) => {
        if (value?.fudocWeb || value?.webDate || value?.webURL) {
          return !!value?.fudocWeb && !!value?.webDate && !!value?.webURL;
        } else {
          return true;
        }
      },
    )
    .test(
      "balance dates must me max year apart",
      t(
        "Ελέγξτε τις ημερομηνίες χρήσης. Η ημερομηνία έναρξης χρήσης πρέπει να απέχει το πολύ ένα χρόνο από την ημερομηνία λήξης.",
      ),
      (value) => {
        const { usageFromDate, usageToDate } = value;
        if (!usageFromDate || !usageToDate) return false;
        return (
          0 <= differenceInDays(usageToDate, usageFromDate) &&
          differenceInDays(usageToDate, usageFromDate) <= 365
        );
      },
    )
    .test(
      "has filled all of paper",
      t(
        "Εάν επιθυμείτε να εισάγετε τα στοιχεία της εφημερίδας, πρέπει να συμπληρώσετε όλα τα αντίστοιχα πεδία.",
      ),
      (value) => {
        if (value?.fudocPaper || value?.paperDate || value?.paperName) {
          return (
            !!value?.fudocPaper && !!value?.paperDate && !!value?.paperName
          );
        }
        return true;
      },
    )
    .test(
      "You have not entered auditors",
      t("Δεν έχετε δηλώσει κάποια ελεγκτική εταιρεία ή ελεγκτή."),
      (value) => {
        return (
          (value?.auditCompanies?.length || 0) > 0 ||
          (value?.auditPersons?.length || 0) > 0
        );
      },
    )
    .test(
      "You have not filled all auditCompanies fields",
      t("Υπάρχει μη συμπληρωμένο υποχρεωτικό πεδίο στις ελεγκτικές εταιρείες"),
      (value) => {
        const auditCompanies = value.auditCompanies;

        if (auditCompanies) {
          for (let company of auditCompanies) {
            if (!company.descr || !company.gemiNumber) {
              return false;
            }
          }
        }
        return true;
      },
    )
    .test(
      "You have not filled all auditor fields",
      t("Υπάρχει μη συμπληρωμένο υποχρεωτικό πεδίο στους ελεγκτές"),
      (value) => {
        const auditPersons = value.auditPersons;

        if (auditPersons) {
          for (let person of auditPersons) {
            if (
              !person.afm ||
              !person.auditorTypes ||
              !person.elteNumber ||
              !person.firstName ||
              !person.lastName ||
              !person.fathersName
            ) {
              return false;
            }
          }
        }

        return true;
      },
    );
};
